import request from "@/utils/requestJSON";

export function getDifferentServiceList() {
  return request({
    url: "/storage/Different/DifferentServiceList.json",
    method: "get",
  });
}

export function getDifferentServiceInfo() {
  return request({
    url: "/storage/Different/DifferentServiceInfo.json",
    method: "get",
  });
}
